var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 18.8383H21.9997V29.8383H58.6663V18.8383H65.9997V37.1716H73.333V11.505H50.673C49.133 7.25163 45.0997 4.17163 40.333 4.17163C35.5663 4.17163 31.533 7.25163 29.993 11.505H7.33301V77.505H32.9997V70.1716H14.6663V18.8383ZM40.333 11.505C42.3497 11.505 43.9997 13.155 43.9997 15.1716C43.9997 17.1883 42.3497 18.8383 40.333 18.8383C38.3163 18.8383 36.6663 17.1883 36.6663 15.1716C36.6663 13.155 38.3163 11.505 40.333 11.505Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7663 69.805C72.233 67.2383 73.333 64.305 73.333 61.005C73.333 51.8383 65.9997 44.505 56.833 44.505C47.6663 44.505 40.333 51.8383 40.333 61.005C40.333 70.1716 47.6663 77.505 56.833 77.505C60.133 77.505 63.0663 76.405 65.633 74.9383L75.533 84.8383L80.6663 79.705L70.7663 69.805ZM56.833 70.1716C51.6997 70.1716 47.6663 66.1383 47.6663 61.005C47.6663 55.8716 51.6997 51.8383 56.833 51.8383C61.9663 51.8383 65.9997 55.8716 65.9997 61.005C65.9997 66.1383 61.9663 70.1716 56.833 70.1716Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.c889a3b5827d8b25674c84e649c76463.svg";
export { ForwardRef as ReactComponent };